import { get, post, deleteRequest, patch, downloadFile } from 'utils/api';

export const getVehicle = (data) => {
  return get(`/vehicles`, data);
};
export const getVehicleById = (id) => {
  return get(`/vehicles/${id}`);
};

export const addVehicle = (data) => {
  return post(`/vehicles`, data);
};

export const addMultipleVehicle = (data) => {
  return downloadFile(`/vehicles/multipleVehicle`, data);
};

export const updateVehicle = (data) => {
  const id = data.id;
  delete data['id'];

  return patch(`/vehicles/${id}`, data);
};

export const deleteVehicle = (id) => {
  return deleteRequest(`/vehicles/${id}`);
};

export const downloadExcelVehicle = (data) => {
  if (data.company && data.search) {
    const companyId = data.company;
    const search = encodeURIComponent(data.search);
    delete data['company'];
    delete data['search'];
    return downloadFile(`/vehicles/viewVehicles?company=${companyId}&search=${search}`, data);
  } else if (data.company) {
    const companyId = data.company;
    delete data['company'];
    return downloadFile(`/vehicles/viewVehicles?company=${companyId}`, data);
  } else if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return downloadFile(`/vehicles/viewVehicles?search=${search}`, data);
  } else {
    return downloadFile(`/vehicles/viewVehicles`, data);
  }
};
export const vehicle = {
  getVehicle,
  getVehicleById,
  addVehicle,
  addMultipleVehicle,
  updateVehicle,
  deleteVehicle,
  downloadExcelVehicle,
};
